'use strict';

import { processInclude } from 'util/common';
import { newModalFromString } from './components/modal';
import { applyRendering } from './util/render';
import GiftcardHelper from './giftcard/giftcardAddToCart';
import productHelpers from './product/base';

const formatDate = (date, formatPattern) => {
    if (formatPattern === 'dd-mm-yyyy') {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
    } else if (formatPattern === 'mm-dd-yyyy') {
        return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' + date.getFullYear();
    } else if (formatPattern === 'yyyy年mm月dd日') {
        var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
        return dateParsed;
    }
};

class GiftCard {
    init () {
        // Gift card selection variables
        this.selectedOccasion = null;
        this.selectedSwatchIndex = null;
        this.selectedColor = null;

        // Class variables
        this.occasionElement = '.js-occasion-tab';
        this.swatchesContainer = '.js-giftcard-slider-nav';
        this.carousel = '.js-giftcard-carousel';
        this.swatchesElement = '.js-giftcard-swatch';
        this.colorsSection = '.js-giftCardPage-colorSwatches';
        this.colorsContainer = '.js-giftcard-color-list';
        this.colorsElement = '.js-giftcard-select-color';
        this.colorName = '.js-giftcard-color-name';
        this.giftCardImage = '.js-giftcard-image';
        this.giftCardPriceBanner = '.js-giftCardPage-price-banner';
        this.amounts = '.js-giftcard-amount-option';
        this.manualAmount = '.js-giftcard-amount-manual';
        this.sliderConfig = {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            infinite: false,
            dots: false,
            focusOnSelect: true,
            accessibility: false,
            arrows: false,
            speed: 0
        };

        // Initialize selection of first elements
        var firstOccasionName = $(this.occasionElement).first().data('occasion');
        var firstSwatchIndex = 0;
        var firstColorId = $(`${this.colorsContainer}[data-occasion="${firstOccasionName}"]`).find(this.colorsElement).first().data('color-id');
        this._selectOccasion(firstOccasionName, firstSwatchIndex, firstColorId);

        // Initialize colors
        const _self = this;
        $(this.colorsElement).each(function (index, element) {
            let colorName = $(element).data('display-value');
            let colorCode = $(element).data('code');
            $(element).css('background-color', colorCode);
            if (index === 0) {
                $(_self.colorName).text(colorName);
            }
        });

        // Class methods
        this.giftCardEventListeners();
        this.formListeners();
        this.initializeDateSelector();
        this.initParsleyValidator();
        this.initSwatches();
        this.initModalPreview();

        // Legacy imports
        processInclude(require('./giftcard/giftcardBalance'));
        processInclude(require('./checkout/giftcard'));
        GiftcardHelper.addToCart();

        productHelpers.run();
    }

    _selectOccasion (occasionName, swatchIndex, colorId) {
        // Reset all occasions
        $(this.occasionElement).removeClass('selected');

        // Select occasion based on name
        const $selectedOccasion = $(`${this.occasionElement}[data-occasion="${occasionName}"]`);
        $selectedOccasion.addClass('selected');
        this.selectedOccasion = occasionName;

        // Select swatch slider and color list
        this._selectSwatch(occasionName, swatchIndex, colorId);
    }

    _selectSwatch (occasionName, swatchIndex, colorId) {
        // Reset all swatches
        $(this.swatchesContainer).removeClass('selected');
        $(this.swatchesElement).removeClass('selected');

        // Select swatch container
        const $selectedSwatchContainer = $(`${this.swatchesContainer}[data-occasion="${occasionName}"]`);
        $selectedSwatchContainer.addClass('selected');

        // Select swatch element
        const $selectedSwatch = $selectedSwatchContainer.find(`${this.swatchesElement}[data-index="${swatchIndex}"]`);
        $selectedSwatch.addClass('selected');

        // Update selected swatch index
        this.selectedSwatchIndex = swatchIndex;

        // Select color list
        this._selectColorsList(occasionName, swatchIndex, colorId);
    }

    _selectColorsList (occasionName, swatchIndex, colorId) {
        // Reset colors list
        $(this.colorsContainer).removeClass('selected');

        // Select color list (hide entire container if no color list is available)
        const $selectedColorList = $(`${this.colorsContainer}[data-occasion="${occasionName}"]`);
        $(this.colorsSection).toggleClass('hide', $selectedColorList.length === 0);
        $selectedColorList.addClass('selected');

        this._selectColor(occasionName, swatchIndex, colorId);
    }

    _selectColor (occasionName, swatchIndex, colorId) {
        // Reset colors
        $(this.colorsElement).removeClass('selected');

        // Retrieve selected color of current list and highlight it
        const $selectedColorList = $(`${this.colorsContainer}[data-occasion="${occasionName}"]`);
        const $selectedColor = $selectedColorList.find(`${this.colorsElement}[data-color-id="${colorId}"]`);
        $selectedColor.addClass('selected');
        $(this.colorName).text($selectedColor.data('display-value'));
        this.selectedColor = colorId;

        // Update carousel
        var $carousel = '';
        $(this.giftCardImage).each(function (index, element) {
            if ($(element).data('occasion') === occasionName && $(element).data('color-id') === colorId) {
                let src = $(element).val();
                let alt = $(element).data('alt') || `${occasionName} occasion ${ colorId ? 'of color ' + colorId : ''}`; // Remove fallback when alt label is provided
                $carousel += applyRendering('sliderCarouselItem', {
                    src: src,
                    alt: alt,
                    index: String(index)
                });
            }
        });

        // Rebuild slick slider
        if ($(this.carousel).hasClass('slick-initialized')) {
            $(this.carousel).slick('unslick');
        }
        $(this.giftCardPriceBanner).addClass('hide');
        $(this.carousel).empty();
        $(this.carousel).html($carousel);
        $(this.carousel).slick(this.sliderConfig);
        $(this.giftCardPriceBanner).removeClass('hide');
        $(this.carousel).slick('slickGoTo', swatchIndex, true);

        // Update image name to be added
        var selectedImageUrl = $(`${this.giftCardImage}[data-occasion="${occasionName}"][data-index="${swatchIndex}"][data-color-id="${colorId}"]`).val();
        if (selectedImageUrl && selectedImageUrl.length > 0) {
            var selectedImageUrlArray = selectedImageUrl.split('/');
            var selectedImageName = selectedImageUrlArray[selectedImageUrlArray.length - 1].replace('.jpg', '');
            $('.js-giftCardPage-giftCardAddToCartGlobal').data('egc-image-name', selectedImageName).attr('data-egc-image-name', selectedImageName);
        }
    }

    updateAmountDisplay (amount, isCurrencyFormatPrefix, currencySymbol) {
        let amountParsed = parseInt(amount);
        if (amount && amountParsed !== 0) {
            let formatDisplayMoney = isCurrencyFormatPrefix ? currencySymbol + ' ' + amountParsed : amountParsed + ' ' + currencySymbol;
            $('.js-sliderForPriceStamp_amount.js-amount-money').text(formatDisplayMoney);
            $('.js-price-value').text(formatDisplayMoney);
        }
    }

    giftCardEventListeners () {
        const $giftCardPageElement = $('.cc-giftCardPage');
        const currencySymbol = $giftCardPageElement.data('currency-symbol');
        const isCurrencyFormatPrefix = $giftCardPageElement.data('is-currency-format-prefix') === true;
        const _self = this;

        // Manage occasion selection
        $('body').on('click', this.occasionElement + ':not(.selected)', function (e) {
            e.preventDefault();
            var newOccasionSelection = $(e.currentTarget).data('occasion');
            var firstColorId = $(`${_self.colorsContainer}[data-occasion="${newOccasionSelection}"]`).find(_self.colorsElement).first().data('color-id') || '';
            _self._selectOccasion(newOccasionSelection, 0, firstColorId);
        });

        // Manage swatch selection
        $('body').on('click', this.swatchesElement + ':not(.selected)', function (e) {
            e.preventDefault();
            var newSwatchSelection = $(e.currentTarget).data('index');
            _self._selectSwatch(_self.selectedOccasion, newSwatchSelection, _self.selectedColor);
        });

        // Manage color selection
        $('body').on('click', this.colorsElement + ':not(.selected)', function (e) {
            e.preventDefault();
            var newColorSelection = $(e.currentTarget).data('color-id');
            _self._selectColor(_self.selectedOccasion, _self.selectedSwatchIndex, newColorSelection);
        });

        // Manage amount selection
        $('body').on('click', this.amounts, function (e) {
            var amount = $(e.currentTarget).val();
            _self.updateAmountDisplay(amount, isCurrencyFormatPrefix, currencySymbol);

            // Clear manual amount input
            $(_self.manualAmount).val('');
        });

        $(this.manualAmount).on('click', function () {
            // De-select amount options
            $(`${_self.amounts}:checked`).prop('checked', false);
        });

        $(this.manualAmount).siblings('.form-fields-item__clearIcon').on('click', function () {
            // Abled amount options
            $(`${_self.amounts}`).prop('disabled', false);
        });

        // Manage amount manual input
        $(this.manualAmount).on('input', function (e) {
            e.preventDefault();
            const value = $(this).val();

            // If blank pre-select first option instead
            if (!value || value.length === 0) {
                const $firstAmountOption = $(_self.amounts).first();

                $firstAmountOption.trigger('click');
                $(`${_self.amounts}`).prop('disabled', false);

                $('.js-price-validation-error').hide();
                return;
            }
            $(`${_self.amounts}`).prop('disabled', true);
            $('.js-price-validation-error').hide();
            if (!value || /[^0-9]/.test(value)) {
                $('.js-price-validation-error').show();
                return;
            }

            var parsedValue = parseInt(value, 10);
            var minimumValue = parseInt($(e.currentTarget).data('min'), 10);
            var maximumValue = parseInt($(e.currentTarget).data('max'), 10);
            if (parsedValue < minimumValue || parsedValue > maximumValue) {
                $('.js-price-validation-error').show();
                $('.js-sliderForPriceStamp_amount').text('--');
                return;
            }

            _self.updateAmountDisplay(value, isCurrencyFormatPrefix, currencySymbol);
        });
    }

    formListeners () {
        $('.js-giftcardNameTo').on('keyup', function (e) {
            e.preventDefault();
            const value = $(this).val();
            $('.js-giftcardNameToStamp').text(value);
        });

        $('.js-giftcardYourName').on('keyup', function (e) {
            e.preventDefault();
            const value = $(this).val();
            $('.js-giftcardYourNameStamp').text(value);
        });

        $('.js-contactFormMessage').on('keyup', function (e) {
            e.preventDefault();
            const value = $(this).val();
            $('.js-contactFormMessageStamp').text(value);
        });

        var maxLength = 230;
        $('.js-contactFormMessage').on('keyup', function (e) {
            e.preventDefault();
            const textlen = maxLength - $(this).val().length;
            $('#egcMessageFeedbackNumber').text(textlen);
        });
    }

    initializeDateSelector () {
        var firstDate = new Date();
        var year = firstDate.getFullYear();
        var month = firstDate.getMonth();
        var day = firstDate.getDate();
        var expiryDate = new Date(year + 3, month, day);
        var formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');

        var formattedDate = formatDate(firstDate, formatPattern);
        var formattedExpiryDate = formatDate(expiryDate, formatPattern);
        $('.js-giftCardDateExpiryStamp').html(formattedExpiryDate);
        $('.datepickerTriggerElement').data('date', formatDate(firstDate, 'dd-mm-yyyy'));
        $('#dp1').val(formattedDate);

        $('.datepickerTriggerElement').fdatepicker({
            format: 'dd-mm-yyyy',
            disableDblClickSelection: true,
            leftArrow: '<<',
            rightArrow: '>>',
            closeIcon: 'X',
            closeButton: false,
            initialDate: new Date(),
            startDate: new Date()
        }).on('changeDate', function (ev) {
            let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
            var datestring = formatDate(date, formatPattern);
            $('#dp1').val(datestring);
            $('.datepickerTriggerElement').data('date', formatDate(date, 'dd-mm-yyyy'));

            let year = date.getFullYear();
            let month = date.getMonth();
            let day = date.getDate();
            let expiry = new Date(year + 3, month, day);
            $('.js-giftCardDateExpiryStamp').html(formatDate(expiry, formatPattern));
        });
    }

    initParsleyValidator () {
        var items = $('.parsleyValidatableElement');
        for (let i = 0; i < items.length; i++) {
            items.eq(i).parsley();
        }
    }

    initSwatches () {
        const _self = this;

        $(this.carousel).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $(`${_self.swatchesElement}.selected`).removeClass('selected');
            $(`${_self.swatchesElement}[data-index="${currentSlide}"]`).addClass('selected');
        });
    }

    initModalPreview () {
        const _self = this;

        $('.js-linkModalGiftCard').on('click', function (e) {
            e.preventDefault();
            const htmlContent = $('.js-ModalGiftCard').html();
            const modalBigContent = newModalFromString(htmlContent, false, ['wrapperModalGiftCard']);

            var giftCardHtmlPreview = $(_self.carousel).find('.slick-active').html() + $(_self.giftCardPriceBanner)[0].outerHTML;
            $('.js-ImgGiftCardStamp').html(giftCardHtmlPreview);

            modalBigContent.open();

            $(modalBigContent.modalBox).find('.close').on('click', function (e) {
                modalBigContent.close();
            });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modalBigContent.close();
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const giftCard = new GiftCard();
    giftCard.init();
});
